"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _InfoItem = _interopRequireDefault(require("@/components/Store/InfoItem.vue"));
var _StepLayout = _interopRequireDefault(require("./StepLayout.vue"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * info:
 * step1 零售店信息 page
 */
/** components */
/** mixins */
/** utils */
var _default2 = exports.default = {
  components: {
    StepLayout: _StepLayout.default,
    InfoItem: _InfoItem.default
  },
  mixins: [_myform.default],
  props: {
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 门店详情信息，仅用于展示不需要编辑的字段
    info: {
      type: Object,
      default: function _default() {
        return {
          storeInfo: {}
        };
      }
    },
    // 表单信息，所有步骤用一个表单
    form: {
      type: Object,
      default: function _default() {
        return {
          storeInfo: {}
        };
      }
    },
    // 表单规则
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isBailianFlag: {
      type: Boolean,
      default: false
    },
    // 是否潜在客户
    isQzkh: {
      type: Boolean,
      default: false
    },
    // 当前页面用到的 所有下拉options配置
    /**
     * optConfig.rtmOptions: [], // 门店RTM类型select
     * optConfig.storeCategoryOptions: [], // 客户类型select（零售店类别）
     * optConfig.storeStructureOptions: [], // 零售店性质select
     * optConfig.ssbtypeOptions: [], // 店招品牌select
     * optConfig.daMethodOptions: [], // 记账方式select
     * optConfig.mainserviceOptions: [], // 主要服务项目select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    var validateInstoreFac = function validateInstoreFac(rule, value, callback) {
      var _this$form$storeInfo = _this.form.storeInfo,
        laundry = _this$form$storeInfo.laundry,
        restRoom = _this$form$storeInfo.restRoom,
        alignment = _this$form$storeInfo.alignment,
        fitting = _this$form$storeInfo.fitting,
        balancing = _this$form$storeInfo.balancing,
        liftingMachine = _this$form$storeInfo.liftingMachine;
      var hasEmptyValue = [laundry, restRoom, alignment, fitting, balancing, liftingMachine].every(function (v) {
        return v === '' || v == null || v === 'N';
      });
      // if (this.isBailianFlag && hasEmptyValue) {
      if (hasEmptyValue) {
        callback(new Error(_this.$t('errorValid.emptySelect')));
      } else {
        callback();
      }
    };
    var validateProject = function validateProject(rule, value, callback) {
      var _this$form$storeInfo2 = _this.form.storeInfo,
        siBalance = _this$form$storeInfo2.siBalance,
        siWheelPosition = _this$form$storeInfo2.siWheelPosition,
        siTireRepair = _this$form$storeInfo2.siTireRepair,
        siValve = _this$form$storeInfo2.siValve,
        siEngineOil = _this$form$storeInfo2.siEngineOil,
        siBrake = _this$form$storeInfo2.siBrake,
        siFacialClean = _this$form$storeInfo2.siFacialClean,
        siPerishableGoods = _this$form$storeInfo2.siPerishableGoods,
        siOther = _this$form$storeInfo2.siOther;
      var hasEmptyValue = [siBalance, siWheelPosition, siTireRepair, siValve, siEngineOil, siBrake, siFacialClean, siPerishableGoods, siOther].every(function (v) {
        return v === '' || v == null || v === 'N';
      });
      // if (this.isBailianFlag && hasEmptyValue) {
      if (hasEmptyValue) {
        callback(new Error(_this.$t('errorValid.emptyProject')));
      } else {
        callback();
      }
    };
    return {
      scrollInitTime: 0,
      // 滚动初始化次数，仅针对有展开功能的页面
      /** form group */
      formLabelWidth: '120px',
      uploadParams: {
        resourceConfigFlag: 'sfe_store'
      },
      // 上传图片配置
      /** other */
      canSubmit: true,
      validateInstoreFac: validateInstoreFac,
      validateProject: validateProject
    };
  },
  computed: {
    // 是否可编辑
    canEdit: function canEdit() {
      return this.mode === 'edit';
    },
    // step导航
    navList: function navList() {
      return [{
        txt: this.$t('storeVisitReport.common.basicInfo')
      }, {
        txt: this.$t('storeVisitReport.common.moreInfo')
      }, {
        txt: this.$t('storeVisitReport.common.RSSAS')
      }, {
        txt: this.$t('storeVisitReport.common.storeSInfo')
      }, {
        txt: this.$t('storeVisitReport.common.storeMS')
      }, {
        txt: this.$t('storeVisitReport.common.facAEq')
      }, {
        txt: this.$t('storeVisitReport.common.otherMsg')
      }];
    },
    photo1HistoryTime: function photo1HistoryTime() {
      return this.info.storeInfo.photo1UpdateTime && this.info.storeInfo.photo1UpdateTime.split(' ')[0] || '';
    },
    photo2HistoryTime: function photo2HistoryTime() {
      return this.info.storeInfo.photo2UpdateTime && this.info.storeInfo.photo2UpdateTime.split(' ')[0] || '';
    },
    photo3HistoryTime: function photo3HistoryTime() {
      return this.info.storeInfo.photo3UpdateTime && this.info.storeInfo.photo3UpdateTime.split(' ')[0] || '';
    }
  },
  methods: {
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      // 百炼的校验
      if (this.isBailianFlag) {
        this.$refs.dataForm.validateField("storeInfo.".concat(key));
      }
    },
    // 格式化 零售店类别
    formatRType: function formatRType(key) {
      return (0, _index.formatKeyValue)(key, this.optConfig.RTypeOptions);
    },
    // 高度改变，滚动改变
    onScollChange: function onScollChange() {
      this.scrollInitTime++;
    },
    // 保存草稿
    onSaveDraft: function onSaveDraft() {
      console.log('保存草稿');
      this.$emit('draft');
    },
    // 保存并下一步
    onDraftAndGo: function onDraftAndGo() {
      var _this2 = this;
      console.log('保存并下一步');
      this.$refs['dataForm'].clearValidate();
      this.$refs['dataForm'].validate(function (valid) {
        if (!valid) {
          _this2.$message.error(_this2.$t('errorValid.formError'));
          return false;
        }
        _this2.$emit('draftAndGo');
      });
    },
    // 下一步
    onNext: function onNext() {
      console.log('下一步');
      this.$emit('next');
    }
  }
};